// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guest-registration {
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  animation: slideIn 0.3s ease;
}

.form-section {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 2.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.form-header {
  text-align: center;
  margin-bottom: 2rem;
}

.form-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1rem;
  color: #00ff9f;
  filter: drop-shadow(0 0 10px rgba(0, 255, 162, 0.3));
}

.form-header h2 {
  color: #fff;
  margin-bottom: 0.5rem;
  font-size: 2rem;
  background: linear-gradient(135deg, #00ff9f, #00b8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.form-header p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
  line-height: 1.5;
}

.registration-form {
  margin-bottom: 2rem;
}

.input-group {
  margin-bottom: 1.5rem;
}

.input-group label {
  display: block;
  color: #fff;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.name-input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #00ff9f;
  border-radius: 12px;
  background: #ffffff;
  color: #000000 !important;
  font-size: 1.1rem;
  transition: all 0.3s ease;
}

.name-input:focus {
  outline: none;
  border-color: #00ff9f;
  box-shadow: 0 0 20px rgba(0, 255, 162, 0.3);
}

.name-input::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

.name-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.register-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #00ff9f, #00b8ff);
  color: #000;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.register-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 255, 162, 0.4);
}

.register-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.error-message {
  background: rgba(255, 82, 82, 0.2);
  border: 1px solid #ff5252;
  color: #ff5252;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: 500;
}

.benefits {
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.benefits h3 {
  color: #fff;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.benefits ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.benefits li {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0.8rem;
  padding-left: 2rem;
  position: relative;
  line-height: 1.4;
}

.benefits li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background: #00ff9f;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0, 255, 162, 0.5);
}

/* Success State */
.success-state {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 2.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.success-header {
  margin-bottom: 2rem;
}

.success-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1rem;
  color: #00ff9f;
  filter: drop-shadow(0 0 15px rgba(0, 255, 162, 0.5));
}

.success-header h2 {
  color: #fff;
  margin-bottom: 0.5rem;
  font-size: 2rem;
}

.success-header p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
  font-size: 1.1rem;
}

.qr-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin: 2rem 0;
  align-items: start;
}

.qr-code-container {
  background: #fff;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.qr-code-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.qr-code-container p {
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
  font-size: 1.1rem;
}

.download-btn {
  background: linear-gradient(135deg, #00ff9f, #00b8ff);
  color: #000;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 255, 162, 0.4);
}

.qr-instructions {
  text-align: left;
}

.qr-instructions h3 {
  color: #fff;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.qr-instructions ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.qr-instructions li {
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 1rem;
  padding-left: 2rem;
  position: relative;
  line-height: 1.5;
}

.success-actions {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.secondary-btn {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 12px 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.secondary-btn:hover {
  border-color: #00ff9f;
  box-shadow: 0 0 20px rgba(0, 255, 162, 0.3);
  transform: translateY(-2px);
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .guest-registration {
    margin: 1rem;
    padding: 1rem;
  }
  
  .form-section,
  .success-state {
    padding: 2rem;
  }
  
  .form-header h2,
  .success-header h2 {
    font-size: 1.5rem;
  }
  
  .qr-section {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .qr-instructions {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GuestRegistration.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".guest-registration {\n  max-width: 600px;\n  margin: 2rem auto;\n  padding: 2rem;\n  animation: slideIn 0.3s ease;\n}\n\n.form-section {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 2.5rem;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.form-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.form-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 1rem;\n  color: #00ff9f;\n  filter: drop-shadow(0 0 10px rgba(0, 255, 162, 0.3));\n}\n\n.form-header h2 {\n  color: #fff;\n  margin-bottom: 0.5rem;\n  font-size: 2rem;\n  background: linear-gradient(135deg, #00ff9f, #00b8ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.form-header p {\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.registration-form {\n  margin-bottom: 2rem;\n}\n\n.input-group {\n  margin-bottom: 1.5rem;\n}\n\n.input-group label {\n  display: block;\n  color: #fff;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.name-input {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid #00ff9f;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #000000 !important;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n}\n\n.name-input:focus {\n  outline: none;\n  border-color: #00ff9f;\n  box-shadow: 0 0 20px rgba(0, 255, 162, 0.3);\n}\n\n.name-input::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.name-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.register-btn {\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(135deg, #00ff9f, #00b8ff);\n  color: #000;\n  border: none;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.register-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 30px rgba(0, 255, 162, 0.4);\n}\n\n.register-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.error-message {\n  background: rgba(255, 82, 82, 0.2);\n  border: 1px solid #ff5252;\n  color: #ff5252;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  text-align: center;\n  font-weight: 500;\n}\n\n.benefits {\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.benefits h3 {\n  color: #fff;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n}\n\n.benefits ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.benefits li {\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 0.8rem;\n  padding-left: 2rem;\n  position: relative;\n  line-height: 1.4;\n}\n\n.benefits li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  background: #00ff9f;\n  border-radius: 50%;\n  box-shadow: 0 0 10px rgba(0, 255, 162, 0.5);\n}\n\n/* Success State */\n.success-state {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 2.5rem;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.success-header {\n  margin-bottom: 2rem;\n}\n\n.success-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 1rem;\n  color: #00ff9f;\n  filter: drop-shadow(0 0 15px rgba(0, 255, 162, 0.5));\n}\n\n.success-header h2 {\n  color: #fff;\n  margin-bottom: 0.5rem;\n  font-size: 2rem;\n}\n\n.success-header p {\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 0;\n  font-size: 1.1rem;\n}\n\n.qr-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  margin: 2rem 0;\n  align-items: start;\n}\n\n.qr-code-container {\n  background: #fff;\n  border-radius: 16px;\n  padding: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.qr-code-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n}\n\n.qr-code-container p {\n  color: #333;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.download-btn {\n  background: linear-gradient(135deg, #00ff9f, #00b8ff);\n  color: #000;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.download-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 255, 162, 0.4);\n}\n\n.qr-instructions {\n  text-align: left;\n}\n\n.qr-instructions h3 {\n  color: #fff;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n}\n\n.qr-instructions ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.qr-instructions li {\n  color: rgba(255, 255, 255, 0.9);\n  margin-bottom: 1rem;\n  padding-left: 2rem;\n  position: relative;\n  line-height: 1.5;\n}\n\n.success-actions {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.secondary-btn {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 12px 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.secondary-btn:hover {\n  border-color: #00ff9f;\n  box-shadow: 0 0 20px rgba(0, 255, 162, 0.3);\n  transform: translateY(-2px);\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .guest-registration {\n    margin: 1rem;\n    padding: 1rem;\n  }\n  \n  .form-section,\n  .success-state {\n    padding: 2rem;\n  }\n  \n  .form-header h2,\n  .success-header h2 {\n    font-size: 1.5rem;\n  }\n  \n  .qr-section {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .qr-instructions {\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
